// extracted by mini-css-extract-plugin
export default {"titleHighlight":"ViennaClassModal_titleHighlight__JZse1"};